import { themeColors } from "@dana/MobiusOverrides/styles/colors";
import { addTagsModalStyles } from "@dana/Overrides/Widgets/MyListsDetails/AddTagsModal";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { css } from "styled-components";

addTagsModalStyles.tagInputText = mergeToNew(addTagsModalStyles.tagInputText, {
    cssOverrides: {
        inputSelect: css`
            &:not(.react-datetime-picker__inputGroup__input) {
                &:focus-visible {
                    box-shadow: none;
                }
            }
        `,
    },
});
